module.exports = __webpack_public_path__ + "img/Kugel_Geheimnisse.b951571c.svg";